var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',{attrs:{"items":_vm.stations,"value":_vm.value,"label":"Start station","error-messages":_vm.errorMessage,"menu-props":"auto","dark":""},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }